import { LayoutOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Empty } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useChatList } from '../../../contexts/ChatListContext';

const EmptyFeed = ({ activeTab, isDarkMode }) => {
  const navigate = useNavigate();
  const { chats } = useChatList();

  const getEmptyConfig = () => {
    if (activeTab === 'my-posts') {
      return {
        description: "You haven't shared any conversations yet",
        buttonText: "Browse My Chats",
        buttonIcon: <LayoutOutlined />,
        action: () => {
          if (chats.length > 0) {
            navigate(`/chat/${chats[0].id}`, { state: { fromNewChatPage: true } });
          } else {
            navigate('/'); // a chat is what they asked for; "/" is New Chat again since 2026-09-16
          }
        }
      };
    }

    return {
      description: "No posts available in the community feed",
      buttonText: "Create Your First Post",
      buttonIcon: <PlusOutlined />,
      action: () => navigate('/')
    };
  };

  const config = getEmptyConfig();

  return (
    <div className={`empty-feed ${isDarkMode ? 'dark' : 'light'}`}>
      <Empty
        description={config.description}
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        className="empty-state"
      >
        <Button
          type="primary"
          icon={config.buttonIcon}
          onClick={config.action}
          size="large"
        >
          {config.buttonText}
        </Button>
      </Empty>
    </div>
  );
};

export default EmptyFeed;
